import { resources } from "../../../../../../../core/models/resource/resources";
import { ColumnPropertyLazySelect } from "../../../../../../../core/types/records-table.types";

export const rrcLimitsResourceType = resources['rrc-limits'];
export const changeRrcLimitModalName = 'change-rrc-limit';

export const propertyLazySelectChangeRrcLimit: ColumnPropertyLazySelect = {
  recourseName: 'RrcLimitDto',
  providerType: 'RRC_LIMIT'
}
